module.exports = __webpack_public_path__ + "media/images/id-lang-0ccedab3e0a27a9e83faef34796ec49a.png";